<div class="content">
  <app-header></app-header>

  <div class="content-inner">
    <router-outlet></router-outlet>
  </div>
</div>
<app-mobile-footer-nav class="tablet-show"></app-mobile-footer-nav>
<app-footer></app-footer>
